// extracted by mini-css-extract-plugin
export default {"wrapper":"style__wrapper--qmJ5m","container":"style__container--otiRh","checkbox":"style__checkbox--GxQQQ"};